<template>

  <div class="norte rombo-team">
    <div class="fila d-flex flex-row justify-content-center" v-for="fila in filas">

      <rombo-persona
        v-for="persona in fila"
        :key="`persona_${persona.id}`"
        :persona="persona"
        :ref="`foto_${persona.name}`"
        @mouseover="cambiarFoto"
        @mouseleave="mirarAlFrente"
        @click="updateSelected"
      ></rombo-persona>

    </div>
  </div>

</template>

<script>
  import Rombo from '../components/Rombo'
  import foto from '../assets/images/aboutUs/romboCentral.png'
  import juzielFront from '../assets/images/aboutUs/romboTeam/Juziel/juzielFront.png'
  import juzielBottom from '../assets/images/aboutUs/romboTeam/Juziel/juzielBottom.png'
  import juzielBottomLeft from '../assets/images/aboutUs/romboTeam/Juziel/juzielBottomLeft.png'
  import juzielBottomRight from '../assets/images/aboutUs/romboTeam/Juziel/juzielBottomRight.png'

  import andreinaFront from '../assets/images/aboutUs/romboTeam/Andreina/andreinaFront.png'
  import andreinaTopRight from '../assets/images/aboutUs/romboTeam/Andreina/andreinaTopRight.png'
  import andreinaBottomRight from '../assets/images/aboutUs/romboTeam/Andreina/andreinaBottomRight.png'
  import andreinaLeft from '../assets/images/aboutUs/romboTeam/Andreina/andreinaTopLeft.png'
  import andreinaTop from '../assets/images/aboutUs/romboTeam/Andreina/andreinaTop.png'
  import andreinaRight from '../assets/images/aboutUs/romboTeam/Andreina/andreinaRight.png'

  import danielaFront from '../assets/images/aboutUs/romboTeam/Daniela/danielaFront.png'
  import danielaRight from '../assets/images/aboutUs/romboTeam/Daniela/danielaRight.png'
  import danielaBottomRight from '../assets/images/aboutUs/romboTeam/Daniela/danielaBottomRight.png'
  import danielaTopRight from '../assets/images/aboutUs/romboTeam/Daniela/danielaTopRight.png'

  import koraFront from '../assets/images/aboutUs/romboTeam/Kora/koraFront.png'
  import koraLeft from '../assets/images/aboutUs/romboTeam/Kora/koraLeft.png'
  import koraBottomLeft from '../assets/images/aboutUs/romboTeam/Kora/koraBottomLeft.png'
  import koraTopLeft from '../assets/images/aboutUs/romboTeam/Kora/koraTopLeft.png'

  import vladimirFront from '../assets/images/aboutUs/romboTeam/Vladimir/vladimirFront.png'
  import vladimirTopLeft from '../assets/images/aboutUs/romboTeam/Vladimir/vladimirTopLeft.png'
  import vladimirTop from '../assets/images/aboutUs/romboTeam/Vladimir/vladimirTop.png'
  import vladimirTopRight from '../assets/images/aboutUs/romboTeam/Vladimir/vladimirTopRight.png'

  import jahiezerFront from '../assets/images/aboutUs/romboTeam/Jahiezer/jahiezerFront.png'
  import jahiezerTopRight from '../assets/images/aboutUs/romboTeam/Jahiezer/jahiezerTopRight.png'
  import jahiezerLeft from '../assets/images/aboutUs/romboTeam/Jahiezer/jahiezerRight.png'
  import jahiezerBottomRight from '../assets/images/aboutUs/romboTeam/Jahiezer/jahiezerBottomRight.png'
  import jahiezerBottom from '../assets/images/aboutUs/romboTeam/Jahiezer/jahiezerBottom.png'
  import jahiezerBottomLeft from '../assets/images/aboutUs/romboTeam/Jahiezer/jahiezerBottomLeft.png'

  import joseFront from '../assets/images/aboutUs/romboTeam/Jose/joseFront.png'
  import joseTopLeft from '../assets/images/aboutUs/romboTeam/Jose/joseTopLeft.png'
  import joseLeft from '../assets/images/aboutUs/romboTeam/Jose/joseRight.png'
  import joseBottomRight from '../assets/images/aboutUs/romboTeam/Jose/joseBottomRight.png'
  import joseBottom from '../assets/images/aboutUs/romboTeam/Jose/joseBottom.png'
  import joseBottomLeft from '../assets/images/aboutUs/romboTeam/Jose/joseBottomLeft.png'

  import raquelFront from '../assets/images/aboutUs/romboTeam/Raquel/raquelFront.png'
  import raquelTop from '../assets/images/aboutUs/romboTeam/Raquel/raquelTop.png'
  import raquelBottomLeft from '../assets/images/aboutUs/romboTeam/Raquel/raquelBottomLeft.png'
  import raquelLeft from '../assets/images/aboutUs/romboTeam/Raquel/raquelLeft.png'
  import raquelTopLeft from '../assets/images/aboutUs/romboTeam/Raquel/raquelTopLeft.png'
  import raquelTopRight from '../assets/images/aboutUs/romboTeam/Raquel/raquelTopRight.png'
  import RomboPersona from './RomboPersona.vue'

  export default {
    components: {
      RomboPersona,
      Rombo },
    name: 'team',
    data () {
      return {
        filas: [
          [
            {
              id: 0,
              name: 'Juziel',
              fotos: {
                'front': juzielFront,
                'topleft': foto,
                'top': foto,
                'topright': foto,
                'left': foto,
                'right': foto,
                'bottomleft': juzielBottomLeft,
                'bottom': juzielBottom,
                'bottomright': juzielBottomRight
              }
            }
          ],
          [
            {
              id: 1,
              name: 'Jahiezer',
              fotos: {
                'front': jahiezerFront,
                'topleft': foto,
                'top': foto,
                'topright': jahiezerTopRight,
                'left': jahiezerLeft,
                'right': foto,
                'bottomleft': jahiezerBottomLeft,
                'bottom': jahiezerBottom,
                'bottomright': jahiezerBottomRight
              }
            },
            {
              id: 2,
              name: 'Jose',
              fotos: {
                'front': joseFront,
                'topleft': joseTopLeft,
                'top': foto,
                'topright': foto,
                'left': joseLeft,
                'right': foto,
                'bottomleft': joseBottomLeft,
                'bottom': joseBottom,
                'bottomright': joseBottomRight
              }
            }
          ],
          [
            {
              id: 3,
              name: 'Daniela',
              fotos: {
                'front': danielaFront,
                'topleft': foto,
                'top': foto,
                'topright': danielaTopRight,
                'left': foto,
                'right': danielaRight,
                'bottomleft': foto,
                'bottom': foto,
                'bottomright': danielaBottomRight
              }
            },
            {
              id: 4,
              name: 'Persona5',
              fotos: {
                'front': foto,
                'topleft': foto,
                'top': foto,
                'topright': foto,
                'left': foto,
                'right': foto,
                'bottomleft': foto,
                'bottom': foto,
                'bottomright': foto
              }
            },
            {
              id: 5,
              name: 'Kora',
              fotos: {
                'front': koraFront,
                'topleft': koraTopLeft,
                'top': foto,
                'topright': foto,
                'left': koraLeft,
                'right': foto,
                'bottomleft': koraBottomLeft,
                'bottom': foto,
                'bottomright': foto
              }
            }
          ],
          [
            {
              id: 6,
              name: 'Andreina',
              fotos: {
                'front': andreinaFront,
                'topleft': foto,
                'top': andreinaTop,
                'topright': andreinaTopRight,
                'left': andreinaLeft,
                'right': andreinaRight,
                'bottomleft': foto,
                'bottom': foto,
                'bottomright': andreinaBottomRight
              }
            },
            {
              id: 7,
              name: 'Raquel',
              fotos: {
                'front': raquelFront,
                'topleft': raquelTopLeft,
                'top': raquelTop,
                'topright': raquelTopRight,
                'left': raquelLeft,
                'right': foto,
                'bottomleft': raquelBottomLeft,
                'bottom': foto,
                'bottomright': foto
              }
            }
          ],
          [
            {
              id: 8,
              name: this.$t('aboutUs.us.designer'),
              class: 'anonymous',
              fotos: {
                'front': vladimirFront,
                'topleft': vladimirTopLeft,
                'top': vladimirTop,
                'topright': vladimirTopRight,
                'left': foto,
                'right': foto,
                'bottomleft': foto,
                'bottom': foto,
                'bottomright': foto
              }
            }
          ]
        ]
      }
    },
    methods: {
      updateSelected: function (item) {
        this.$emit('showingOpen', item)
      },
      cambiarFoto ({ name }) {
        switch (name) {
          case 'Juziel':
            this.$refs.foto_Juziel[0].switchFoto('front')
            this.$refs.foto_Jahiezer[0].switchFoto('topright')
            this.$refs.foto_Jose[0].switchFoto('topleft')
            this.$refs.foto_Daniela[0].switchFoto('topright')
            this.$refs.foto_Kora[0].switchFoto('topleft')
            this.$refs.foto_Andreina[0].switchFoto('topright')
            this.$refs.foto_Raquel[0].switchFoto('topleft')
            this.$refs.foto_Designer[0].switchFoto('top')
            break
          case 'Jahiezer':
            this.$refs.foto_Juziel[0].switchFoto('bottomleft')
            this.$refs.foto_Jahiezer[0].switchFoto('front')
            this.$refs.foto_Jose[0].switchFoto('left')
            this.$refs.foto_Daniela[0].switchFoto('topright')
            this.$refs.foto_Kora[0].switchFoto('topleft')
            this.$refs.foto_Andreina[0].switchFoto('top')
            this.$refs.foto_Raquel[0].switchFoto('topleft')
            this.$refs.foto_Designer[0].switchFoto('topleft')
            break
          case 'Jose':
            this.$refs.foto_Juziel[0].switchFoto('bottomright')
            this.$refs.foto_Jahiezer[0].switchFoto('left')
            this.$refs.foto_Jose[0].switchFoto('front')
            this.$refs.foto_Daniela[0].switchFoto('right')
            this.$refs.foto_Kora[0].switchFoto('topleft')
            this.$refs.foto_Andreina[0].switchFoto('topright')
            this.$refs.foto_Raquel[0].switchFoto('top')
            this.$refs.foto_Designer[0].switchFoto('topright')
            break
          case 'Daniela':
            this.$refs.foto_Juziel[0].switchFoto('bottomleft')
            this.$refs.foto_Jahiezer[0].switchFoto('bottomleft')
            this.$refs.foto_Jose[0].switchFoto('bottomleft')
            this.$refs.foto_Daniela[0].switchFoto('front')
            this.$refs.foto_Kora[0].switchFoto('left')
            this.$refs.foto_Andreina[0].switchFoto('left')
            this.$refs.foto_Raquel[0].switchFoto('left')
            this.$refs.foto_Designer[0].switchFoto('topleft')
            break
          case 'Kora':
            this.$refs.foto_Juziel[0].switchFoto('bottomright')
            this.$refs.foto_Jahiezer[0].switchFoto('bottomright')
            this.$refs.foto_Jose[0].switchFoto('bottomright')
            this.$refs.foto_Daniela[0].switchFoto('right')
            this.$refs.foto_Kora[0].switchFoto('front')
            this.$refs.foto_Andreina[0].switchFoto('right')
            this.$refs.foto_Raquel[0].switchFoto('topright')
            this.$refs.foto_Designer[0].switchFoto('topright')
            break
          case 'Andreina':
            this.$refs.foto_Juziel[0].switchFoto('bottom')
            this.$refs.foto_Jahiezer[0].switchFoto('bottom')
            this.$refs.foto_Jose[0].switchFoto('bottomleft')
            this.$refs.foto_Daniela[0].switchFoto('bottomright')
            this.$refs.foto_Kora[0].switchFoto('bottomleft')
            this.$refs.foto_Andreina[0].switchFoto('front')
            this.$refs.foto_Raquel[0].switchFoto('left')
            this.$refs.foto_Designer[0].switchFoto('topleft')
            break
          case 'Raquel':
            this.$refs.foto_Juziel[0].switchFoto('bottom')
            this.$refs.foto_Jahiezer[0].switchFoto('bottomright')
            this.$refs.foto_Jose[0].switchFoto('bottom')
            this.$refs.foto_Daniela[0].switchFoto('bottomright')
            this.$refs.foto_Kora[0].switchFoto('bottomleft')
            this.$refs.foto_Andreina[0].switchFoto('right')
            this.$refs.foto_Raquel[0].switchFoto('front')
            this.$refs.foto_Designer[0].switchFoto('topright')
            break
          case this.$t('aboutUs.us.designer'):
            this.$refs.foto_Juziel[0].switchFoto('bottom')
            this.$refs.foto_Jahiezer[0].switchFoto('bottom')
            this.$refs.foto_Jose[0].switchFoto('bottom')
            this.$refs.foto_Daniela[0].switchFoto('bottomright')
            this.$refs.foto_Kora[0].switchFoto('bottomleft')
            this.$refs.foto_Andreina[0].switchFoto('bottomright')
            this.$refs.foto_Raquel[0].switchFoto('bottomleft')
            this.$refs.foto_Designer[0].switchFoto('front')
            break
          default:
        }
      },
      mirarAlFrente () {
        Object.keys(this.$refs).filter(f => f.startsWith('foto_')).forEach(ref => {
          this.$refs[ref][0].switchFoto('front')
        })
      }
    }
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  .rombo-team {

    .anonymous {

      #contenido {
        mix-blend-mode: saturation;

      }

    }

    .container-center{
      justify-content: center;
      align-items: center
    }

    .tope{
      margin-top: -38px;
    }

    img{
      width: 155px;
      @media (min-width: 1400px) {
        width: 226px;
      }
    }

    .comun{
      width: 120px;
      height: 120px;
      background-repeat:no-repeat;
      background-size: contain;
      background-position: center;
      position: center;

      // Extra large devices
      @media (min-width: 1400px) {
        width: 170px;
        height: 170px;
      }
    }


    .norte{
      margin-left: 8px;
    }

    .fila + .fila {
      margin-top: -35px;

      @media (min-width: 1400px) {
        margin-top: -49px;
      }
    }
    .rom + .rom {
      margin-left: 49px;
      @media (min-width: 1400px) {
        margin-left: 69px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/RomboTeam.vue